<style>
.v-table > .v-table__wrapper > table > thead > tr > th {
  padding: 0 4px !important;
}

.swal2-confirm.swal2-styled {
  background-color: #a61a2f !important;
  box-shadow: none !important;
}

.swal2-warning {
  border-color: #a61a2f !important;
  color: #a61a2f !important;
}

.swal2-show {
  border-radius: 15px !important;
}

.v-btn__content {
  display: flex;
  flex-direction: column;
}
</style>

<template>
  <div
    style="
      padding: 20px;
      margin: 20px;
      background-color: white;
      border-radius: 10px;
    "
  >
    <h2 style="margin-bottom: 15px; font-weight: 600; border-bottom: 1px solid">
      {{ "SOC-" + code.toString().padStart(7, "0") }} - Datos Generales
    </h2>

    <div class="d-flex flex-wrap ga-3">
      <div class="w-in">
        <label>Tipo Solicitud:</label>

        <v-text-field
          v-model="tipo"
          readonly
          pa-1
          ma-0
          autocomplete="off"
          hide-details
          variant="solo"
          color="primary"
          required
        />
      </div>

      <div class="w-in">
        <label>Estado Solicitud:</label>

        <v-text-field
          v-model="estado"
          readonly
          pa-1
          hide-details
          ma-0
          autocomplete="off"
          variant="solo"
          color="primary"
          required
        />
      </div>

      <div class="w-in">
        <label>Fecha Solicitud:</label>

        <v-text-field
          v-model="date"
          readonly
          autocomplete="off"
          pa-1
          hide-details
          ma-0
          variant="solo"
          color="primary"
          required
        />
      </div>

      <div class="w-in" v-if="tipo == 'Rendicion'">
        <label>Fecha Liberación:</label>

        <v-text-field
          v-model="fechaLiberacion"
          readonly
          autocomplete="off"
          pa-1
          hide-details
          ma-0
          variant="solo"
          color="primary"
        />
      </div>

      <div class="w-in">
        <label>Rut Ingresado Por:</label>

        <v-text-field
          variant="solo"
          readonly
          pa-1
          ma-0
          autocomplete="off"
          v-model="solPorId"
          hide-details
        >
        </v-text-field>
      </div>

      <div class="w-in">
        <label>Ingresado Por:</label>
        <v-text-field
          readonly
          variant="solo"
          autocomplete="off"
          pa-1
          ma-0
          v-model="solPorNombre"
          hide-details
        >
        </v-text-field>
      </div>

      <div class="w-in">
        <label>Empresa:</label>

        <v-combobox
          v-model="empresaSel"
          :items="lstEmpresas"
          autocomplete="off"
          variant="solo"
          pa-1
          hide-details
          ma-0
          readonly
          item-title="nameDisplayName"
          item-value="id"
        >
        </v-combobox>
      </div>

      <div class="w-in">
        <label>Departamento:</label>

        <v-combobox
          v-model="departamentoSel"
          variant="solo"
          readonly
          autocomplete="off"
          hide-details
          pa-1
          ma-0
          item-title="codeDisplayName"
          item-value="code"
        >
        </v-combobox>
      </div>

      <div class="w-in" v-if="!isIngresoRespel(tipo) && tipo != 'Rendicion'">
        <label>Rut Solicitante:</label>

        <v-text-field
          variant="solo"
          readonly
          pa-1
          ma-0
          autocomplete="off"
          v-model="solId"
          hide-details
        >
        </v-text-field>
      </div>

      <div class="w-in" v-if="!isIngresoRespel(tipo) && tipo != 'Rendicion'">
        <label>Solicitante:</label>
        <v-text-field
          readonly
          variant="solo"
          pa-1
          autocomplete="off"
          ma-0
          v-model="solNombre"
          hide-details
        >
        </v-text-field>
      </div>

      <div class="w-in" v-if="tipo == 'Compra'">
        <label>Proveedor:</label>

        <v-combobox
          v-model="vendorSel"
          readonly
          hide-details
          autocomplete="off"
          :items="lstVendors"
          variant="solo"
          item-title="numberDisplayName"
          item-value="id"
        >
        </v-combobox>
      </div>

      <div class="w-in" v-if="tipo == 'Compra'">
        <label>Comprador:</label>

        <v-autocomplete
          v-if="estado == 'Enviada'"
          v-model="compradorSel"
          :items="lstCompradores"
          autocomplete="off"
          variant="solo"
          item-title="name"
          item-value="code"
          readonly
          hide-details
          return-object
        >
        </v-autocomplete>

        <v-autocomplete
          v-else
          v-model="compradorSel"
          :items="lstCompradores"
          autocomplete="off"
          variant="solo"
          item-title="name"
          item-value="code"
          clearable
          hide-details
          return-object
        >
        </v-autocomplete>
      </div>

      <div class="w-in" v-if="tipo == 'Compra'">
        <label>¿La solicitud es regularización?</label>

        <v-autocomplete
          v-model="regSel"
          :items="lstRegularizacion"
          variant="solo"
          readonly
          item-title="nombre"
          item-value="id"
          hide-details
          autocomplete="off"
          return-object
        >
        </v-autocomplete>
      </div>

      <div class="w-in" v-if="tipo == 'Compra' && regSel?.id == 'Si'">
        <label>Justificación regularización</label>

        <v-autocomplete
          v-model="justSel"
          :items="lstJustificacion"
          variant="solo"
          readonly
          item-title="nombre"
          item-value="id"
          hide-details
          autocomplete="off"
          return-object
        >
        </v-autocomplete>
      </div>

      <div
        class="w-in"
        v-if="tipo == 'Compra' && regSel?.id == 'Si' && justSel?.id == 5"
      >
        <label>Justificación Autorizada Por:</label>

        <v-autocomplete
          v-model="autorizadorSel"
          variant="solo"
          pa-1
          hide-details
          readonly
          ma-0
          item-title="rutDisplayName"
          item-value="personId"
          autocomplete="off"
          return-object
        >
        </v-autocomplete>
      </div>

      <div
        class="w-in"
        v-if="tipo == 'Compra' && regSel?.id == 'Si' && justSel?.id == 7"
      >
        <label>Descripción Otro:</label>

        <v-textarea
          variant="solo"
          pa-1
          readonly
          ma-0
          v-model="descripOtro"
          hide-details
          autocomplete="off"
        >
        </v-textarea>
      </div>

      <div
        class="w-in"
        v-if="tipo === 'Retiro Bodega' || tipo === 'Retiro RESPEL'"
      >
        <label>Cod. Bod:</label>

        <v-text-field
          variant="solo"
          hide-details
          pa-1
          autocomplete="off"
          ma-0
          readonly
          v-model="bodegaSel"
        >
        </v-text-field>
      </div>

      <div v-if="tipo == 'Retiro Bodega'" class="w-in">
        <label>Codigo Despacho:</label>

        <v-text-field
          variant="solo"
          readonly
          pa-1
          autocomplete="off"
          ma-0
          v-model="codigoDes"
          hide-details
        >
        </v-text-field>
      </div>

      <div v-if="tipo == 'Retiro RESPEL'" class="w-in">
        <label>N° Guía despacho:</label>

        <v-text-field
          variant="solo"
          readonly
          pa-1
          autocomplete="off"
          ma-0
          v-model="codigoDes"
          hide-details
        >
        </v-text-field>
      </div>

      <div v-if="tipo == 'Compra'" class="w-in">
        <label>Num. BC365:</label>

        <v-text-field
          variant="solo"
          readonly
          pa-1
          autocomplete="off"
          ma-0
          v-model="idBc365"
          hide-details
        >
        </v-text-field>
      </div>

      <div class="w-in">
        <label>Observación:</label>

        <v-textarea
          readonly
          variant="solo"
          pa-1
          ma-0
          autocomplete="off"
          v-model="obs"
          hide-details
        >
        </v-textarea>
      </div>

      <div v-if="estado != 'Creada' && !isRespelTipo(tipo)" class="w-in">
        <label v-if="estado == 'Rechazada'">Rechazada Por:</label>
        <label v-if="estado == 'Autorizada'">Autorizada Por:</label>
        <label
          v-if="
            estado == 'Aprobada' ||
            estado == 'Enviada' ||
            estado == 'En Despacho' ||
            estado == 'Despachado' ||
            estado == 'Cerrada'
          "
          >Aprobada Por:</label
        >

        <v-text-field
          readonly
          variant="solo"
          pa-1
          ma-0
          autocomplete="off"
          v-model="nombreAutorizador"
          hide-details
          v-if="estado != 'Anulada'"
        >
        </v-text-field>
      </div>

      <div
        class="w-in"
        v-if="estado != 'Creada' && estado != 'Anulada' && !isRespelTipo(tipo)"
      >
        <label>Motivo:</label>

        <v-text-field
          readonly
          variant="solo"
          pa-1
          ma-0
          v-model="motivo"
          hide-details
        >
        </v-text-field>
      </div>

      <div class="w-in" v-if="tipo == 'Rendicion' && estado == 'Enviada'">
        <label>Enviada Por:</label>

        <v-text-field
          readonly
          variant="solo"
          pa-1
          ma-0
          autocomplete="off"
          v-model="enviadaPor"
          hide-details
        >
        </v-text-field>
      </div>

      <div v-if="adjuntos.length > 0" class="w-in">
        <label>{{ adjuntos.length }} Archivos Adjuntos:</label>

        <div class="text-center d-flex flex-wrap">
          <div
            v-for="(adj, index) in adjuntos"
            :key="index"
            style="align-items: center"
          >
            <v-tooltip :text="adj.nombre">
              <template v-slot:activator="{ props }">
                <v-btn
                  v-bind="props"
                  class="ma-2"
                  style="
                    height: 55px;
                    background-color: #a61a2f;
                    color: white;
                    border-radius: 11px;
                  "
                  @click="bajarAdjunto(sliceString(adj.url))"
                >
                  <v-icon size="x-large">{{ setIcon(adj.nombre) }}</v-icon>
                  <div>Archivo {{ index + 1 }}</div>
                </v-btn>
              </template>
            </v-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    style="
      padding: 20px;
      margin: 20px;
      background-color: white;
      border-radius: 10px;
    "
  >
    <h2 style="margin-bottom: 6px; font-weight: 600; border-bottom: 1px solid">
      Detalle Solicitud
    </h2>

    <div style="display: inline-flex; float: right">
      <v-btn
        prepend-icon="mdi-refresh"
        style="
          background-color: #107167;
          padding: 15px;
          border-radius: 15px;
          color: white;
          margin: 5px 0px 10px 10px;
          display: flex;
          height: 36px;
        "
        :enabled="enabledBC365"
        v-if="esComprador && tipo == 'Compra' && estado == 'Aprobada'"
        @click="updateComprador()"
        >ACTUALIZAR COMPRADOR</v-btn
      >

      <v-btn
        prepend-icon="mdi-export"
        v-on:click="
          exportarPdf('SOC-' + code.toString().padStart(7, '0') + '.pdf')
        "
        style="
          margin: 5px 0px 10px 7px;
          background-color: rgb(166 26 47);
          border-radius: 15px;
          color: white;
          margin-bottom: 8px;
        "
      >
        <template v-slot:prepend>
          <v-icon color="white"></v-icon>
        </template>

        Exportar
      </v-btn>
    </div>

    <v-data-table
      :headers="headers"
      :items="lstDetalle"
      item-key="id"
      v-if="
        tipo == 'Compra' && !isViveres //empresaSel != '18 - TRABAJOS MARITIMOS OXXEAN S.A.'
      "
    >
      <template v-slot:item.isSelected="{ item }">
        <v-checkbox
          v-if="
            (estado == 'Aprobada' || estado == 'En Envio') &&
            item.estadoDespacho != 'Enviada' &&
            item.estadoDespacho != 'Anulada'
          "
          hide-details
          color="red"
          v-model="item.isSelected"
        ></v-checkbox>
      </template>

      <template v-slot:item.material="{ item }">
        {{ item.material }}
      </template>

      <template v-slot:item.precio="{ item }">
        {{ formatMoney(item.precio ?? 0) }}
      </template>

      <template v-slot:item.total="{ item }">
        {{ formatTotal(item.total ?? 0) }}
      </template>

      <template v-slot:item.fechaLimite="{ item }">
        {{ moment(item.fechaLimite).format("DD-MM-YYYY") }}
      </template>
    </v-data-table>

    <v-data-table
      :headers="headersTripulanteViveres"
      :items="lstDetalle"
      item-key="id"
      v-if="
        tipo == 'Compra' &&
        //empresaSel == '18 - TRABAJOS MARITIMOS OXXEAN S.A.' &&
        isViveres
      "
    >
      <template v-slot:item.isSelected="{ item }">
        <v-checkbox
          v-if="
            (estado == 'Aprobada' || estado == 'En Envio') &&
            item.estadoDespacho != 'Enviada' &&
            item.estadoDespacho != 'Anulada'
          "
          hide-details
          color="red"
          v-model="item.isSelected"
        ></v-checkbox>
      </template>

      <template v-slot:item.material="{ item }">
        {{ item.material }}
      </template>

      <template v-slot:item.precio="{ item }">
        {{ formatMoney(item.precio ?? 0) }}
      </template>

      <template v-slot:item.total="{ item }">
        {{ formatTotal(item.total ?? 0) }}
      </template>

      <template v-slot:item.fechaCompra="{ item }">
        {{ moment(item.fechaCompra).format("DD-MM-YYYY") }}
      </template>

      <template v-slot:item.fechaTermino="{ item }">
        {{ moment(item.fechaTermino).format("DD-MM-YYYY") }}
      </template>

      <template v-slot:item.fechaLimite="{ item }">
        {{ moment(item.fechaLimite).format("DD-MM-YYYY") }}
      </template>
    </v-data-table>

    <v-data-table
      :headers="headersRetiro"
      :items="lstDetalle"
      v-if="tipo == 'Retiro Bodega'"
    >
      <template v-slot:item.isSelected="{ item }">
        <v-checkbox
          v-if="
            estado == 'Despachado' &&
            item.estadoDespacho != 'Anulada' &&
            (item.cantidadRetirar ?? 0) > 0
          "
          hide-details
          color="red"
          v-model="item.isSelected"
        ></v-checkbox>
      </template>

      <template v-slot:item.estadoDespacho="{ item }">
        {{ item.estadoDespacho == "Anulada" ? "Anulada" : "" }}
      </template>

      <template v-slot:item.cantidadRetirar="{ item }">
        <div v-if="estado == 'Despachado'">
          <v-text-field
            v-model="item.cantidadRetirar"
            variant="outlined"
            density="compact"
            hide-details
            pa-1
            @keypress="filterNumber($event)"
            autocomplete="off"
            ma-0
          />
        </div>

        <div v-if="estado != 'Despachado'">
          <v-text-field
            v-model="item.cantidadRetirar"
            variant="outlined"
            density="compact"
            :disabled="false"
            hide-details
            pa-1
            @keypress="filterNumber($event)"
            autocomplete="off"
            ma-0
          />
        </div>
      </template>

      <template v-slot:item.chosenFile="{ item }">
        <div v-if="estado != 'Despachado'">
          <v-file-input
            pa-1
            ma-0
            hide-details
            variant="outlined"
            density="compact"
            autocomplete="off"
            readonly
            v-model="item.chosenFile"
          >
          </v-file-input>
        </div>

        <div v-if="estado == 'Despachado'">
          <v-file-input
            pa-1
            ma-0
            hide-details
            variant="outlined"
            density="compact"
            autocomplete="off"
            v-model="item.chosenFile"
          >
          </v-file-input>
        </div>

        <div v-if="item.adjuntoRetiro != null && estado == 'Enviado'">
          <v-btn
            class="ma-2"
            style="
              height: 55px;
              background-color: #a61a2f;
              color: white;
              border-radius: 11px;
            "
            @click="bajarAdjunto(sliceString(item.adjuntoRetiro))"
          >
            <v-icon size="x-large">{{
              setIcon(sliceString(item.adjuntoRetiro))
            }}</v-icon>
            <div>Archivo</div>
          </v-btn>
        </div>
      </template>

      <template v-slot:item.codigoDespacho="{ item }">
        <div v-if="item.retiroBodega && esBodeguero">
          <div v-if="estado == 'En Despacho' || estado == 'Aprobada'">
            <v-text-field
              v-model="item.codigoDespacho"
              variant="outlined"
              density="compact"
              hide-details
              autocomplete="off"
              pa-1
              ma-0
            />
          </div>

          <div v-else>
            <v-text-field
              v-model="item.codigoDespacho"
              variant="outlined"
              density="compact"
              hide-details
              pa-1
              autocomplete="off"
              ma-0
              readonly
            />
          </div>
        </div>

        <div v-else>
          <v-text-field
            v-model="item.codigoDespacho"
            variant="outlined"
            density="compact"
            hide-details
            pa-1
            autocomplete="off"
            ma-0
            disabled
          />
        </div>
      </template>

      <template v-slot:item.actions="{ item }">
        <div v-if="item.retiroBodega && esBodeguero">
          <div v-if="estado == 'En Despacho' || estado == 'Aprobada'">
            <v-btn
              @click="despacharItem(item)"
              style="
                background-color: #10510e;
                margin-top: 10px;
                border-radius: 15px;
                color: white;
                margin-left: 10px;
              "
              >Despachar</v-btn
            >
          </div>
        </div>
      </template>
    </v-data-table>

    <v-data-table
      v-if="tipo == 'Rendicion'"
      :headers="headersRendicion"
      :items="lstDetalle"
    >
      <template v-slot:item.fechaDoc="{ item }">
        {{ item.fechaDoc }}
      </template>

      <template v-slot:item.descGasto="{ item }">
        {{ item.descGasto }}
      </template>

      <template v-slot:item.monto="{ item }">
        {{ formatMoney(item.monto ?? 0) }}
      </template>
    </v-data-table>

    <v-data-table
      v-if="isRespelTipo(tipo)"
      :headers="computedHeadersResiduo"
      :items="lstDetalle"
    ></v-data-table>

    <div
      v-if="
        tipo != 'Rendicion' &&
        estado == 'Creada' &&
        aprobador == 'Aprobador' &&
        tipo != 'Ingreso RESPEL' &&
        tipo != 'Retiro RESPEL'
      "
      style="margin-top: 10px"
      class="class-btn"
    >
      <v-btn
        width="200"
        style="
          margin: 5px;
          background-color: #a61a2f;
          padding: 15px;
          border-radius: 15px;
          color: white;
          margin-left: auto;
          margin-right: auto;
          display: flex;
        "
        density="default"
        @click="dialogRechazar = true"
        >Rechazar Solicitud</v-btn
      >

      <div v-if="estado == 'Creada'">
        <v-btn
          width="200"
          style="
            margin: 5px;
            background-color: #595959;
            padding: 15px;
            border-radius: 15px;
            color: white;
            margin-left: auto;
            margin-right: auto;
            display: flex;
          "
          density="default"
          @click="cambiarEstadoSolicitud('Guardada')"
          >Editar Solicitud</v-btn
        >
      </div>

      <v-btn
        v-if="tipo != 'Retiro RESPEL'"
        width="200"
        style="
          background-color: #10510e;
          padding: 15px;
          margin: 5px;
          border-radius: 15px;
          color: white;
          margin-left: auto;
          margin-right: auto;
          display: flex;
        "
        density="default"
        @click="dialogAprobar = true"
        >Aprobar Solicitud</v-btn
      >
    </div>

    <div
      v-if="tipo == 'Ingreso RESPEL' && estado == 'Creada' && esBodegaRespel"
      style="margin-top: 10px"
      class="class-btn"
    >
      <v-btn
        width="200"
        style="
          margin: 5px;
          background-color: #a61a2f;
          padding: 15px;
          border-radius: 15px;
          color: white;
          margin-left: auto;
          margin-right: auto;
          display: flex;
        "
        density="default"
        @click="dialogRechazar = true"
        >Rechazar Solicitud</v-btn
      >

      <div v-if="estado == 'Creada'">
        <v-btn
          width="200"
          style="
            margin: 5px;
            background-color: #595959;
            padding: 15px;
            border-radius: 15px;
            color: white;
            margin-left: auto;
            margin-right: auto;
            display: flex;
          "
          density="default"
          @click="cambiarEstadoSolicitud('Guardada')"
          >Editar Solicitud</v-btn
        >
      </div>

      <v-btn
        width="200"
        style="
          background-color: #10510e;
          padding: 15px;
          margin: 5px;
          border-radius: 15px;
          color: white;
          margin-left: auto;
          margin-right: auto;
          display: flex;
        "
        density="default"
        @click="dialogAprobar = true"
        >Aprobar Solicitud</v-btn
      >
    </div>

    <div
      v-if="tipo == 'Retiro RESPEL' && estado == 'Creada' && esAprobadorRespel"
      style="margin-top: 10px"
      class="class-btn"
    >
      <v-btn
        width="200"
        style="
          margin: 5px;
          background-color: #a61a2f;
          padding: 15px;
          border-radius: 15px;
          color: white;
          margin-left: auto;
          margin-right: auto;
          display: flex;
        "
        density="default"
        @click="dialogRechazar = true"
        >Rechazar Solicitud</v-btn
      >

      <div v-if="estado == 'Creada'">
        <v-btn
          width="200"
          style="
            margin: 5px;
            background-color: #595959;
            padding: 15px;
            border-radius: 15px;
            color: white;
            margin-left: auto;
            margin-right: auto;
            display: flex;
          "
          density="default"
          @click="cambiarEstadoSolicitud('Guardada')"
          >Editar Solicitud</v-btn
        >
      </div>

      <v-btn
        width="200"
        style="
          background-color: #10510e;
          padding: 15px;
          margin: 5px;
          border-radius: 15px;
          color: white;
          margin-left: auto;
          margin-right: auto;
          display: flex;
        "
        density="default"
        @click="dialogAprobar = true"
        >Aprobar Solicitud</v-btn
      >
    </div>

    <div
      v-if="tipo != 'Retiro Bodega' && !isRespelTipo(tipo)"
      style="
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 5px;
        margin-right: 10px;
        display: flex;
        justify-content: flex-end;
      "
    >
      Total: {{ formatTotal(total) }}
    </div>

    <div
      v-if="
        tipo == 'Rendicion' &&
        estado == 'Creada' &&
        esAutorizador &&
        aprobador == 'Autorizador'
      "
      style="display: flex; margin-top: 10px"
    >
      <v-btn
        width="200"
        style="
          background-color: #a61a2f;
          padding: 15px;
          border-radius: 15px;
          color: white;
          margin-left: auto;
          margin-right: auto;
          display: flex;
        "
        density="default"
        @click="dialogRechazar = true"
        >Rechazar Solicitud</v-btn
      >

      <div v-if="estado = 'Creada'">
        <v-btn
          width="200"
          style="
            margin: 5px;
            background-color: #595959;
            padding: 15px;
            border-radius: 15px;
            color: white;
            margin-left: auto;
            margin-right: auto;
            display: flex;
          "
          density="default"
          @click="cambiarEstadoSolicitud('Guardada')"
          >Editar Solicitud</v-btn
        >
      </div>

      <v-btn
        width="200"
        style="
          background-color: #10510e;
          padding: 15px;
          border-radius: 15px;
          color: white;
          margin-left: auto;
          margin-right: auto;
          display: flex;
        "
        density="default"
        @click="dialogAutorizar = true"
        >Autorizar Solicitud</v-btn
      >
    </div>

    <div style="display: flex; justify-content: end">
      <v-btn
        prepend-icon="mdi-content-copy"
        style="
          width: 200px;
          background-color: #595959;
          padding: 15px;
          border-radius: 15px;
          color: white;
          margin-right: auto;
          display: flex;
        "
        v-if="estado == 'Rechazada' || estado == 'Aprobada'"
        @click="navigate()"
      >
        Copiar Solicitud
      </v-btn>

      <v-btn
        style="
          background-color: #575757;
          padding: 15px;
          border-radius: 15px;
          color: white;
          margin-left: auto;
          display: flex;
        "
        v-if="
          (esAdmin || esComprador || esBodeguero || esContabilidad) &&
          (estado == 'Aprobada' || estado == 'Autorizada')
          // && nulleable
        "
        @click="anularSolicitud()"
      >
        ANULAR SOC
      </v-btn>

      <!-- <v-btn
        style="
          background-color: #575757;
          padding: 15px;
          border-radius: 15px;
          color: white;
          margin-left: auto;
          display: flex;
        "
        v-if="
          (esAdmin || esComprador || esBodeguero || esContabilidad) &&
          (estado == 'Aprobada' ||
            estado == 'Autorizada' ||
            estado == 'En Envio')
          // && nulleable
        "
        @click="anularDetalle()"
      >
        Anular Envio a BC365
      </v-btn> -->

      <v-btn
        style="
          background-color: #575757;
          padding: 15px;
          border-radius: 15px;
          color: white;
          margin-left: auto;
          display: flex;
        "
        v-if="
          (esAdmin || esComprador || esBodeguero || esContabilidad) &&
          (estado == 'Aprobada' ||
            estado == 'Autorizada' ||
            estado == 'En Envio') &&
          tipo == 'Compra'
          // && nulleable
        "
        @click="anularDetalle()"
      >
        ANULAR ÍTEMS
      </v-btn>

      <v-btn
        style="
          width: 200px;
          background-color: #10510e;
          padding: 15px;
          border-radius: 15px;
          color: white;
          margin-left: 5px;
          display: flex;
        "
        :enabled="enabledBC365"
        v-if="esComprador && (estado == 'Aprobada' || estado == 'En Envio')"
        @click="enviarBusinessCentral()"
      >
        Enviar a BC365
      </v-btn>

      <v-btn
        style="
          width: 200px;
          background-color: #10510e;
          padding: 15px;
          border-radius: 15px;
          color: white;
          margin-left: 10px;
          display: flex;
        "
        v-if="esBodeguero && (estado == 'En Despacho' || estado == 'Aprobada')"
        @click="dialogDespachar = true"
      >
        Despachar Solicitud
      </v-btn>

      <div v-if="estado == 'Autorizada' && esContabilidad">
        <v-btn
          style="
            width: 200px;
            background-color: #10510e;
            padding: 15px;
            border-radius: 15px;
            color: white;
            margin-left: auto;
            display: flex;
            margin-left: 5px;
          "
          :enabled="enabledRetiroBC365"
          @click="enviarRendicion()"
        >
          Enviar Rendición
        </v-btn>
      </div>
    </div>

    <div style="display: flex; margin-top: 10px">
      <v-btn
        style="
          background-color: #a61a2f;
          padding: 15px;
          border-radius: 15px;
          color: white;
          margin-left: auto;
          display: flex;
        "
        v-if="esBodeguero && estado == 'En Despacho'"
        @click="dialogCerrar = true"
      >
        Cerrar Solicitud
      </v-btn>
    </div>

    <div style="display: flex; justify-content: end">
      <v-btn
        style="
          background-color: #575757;
          padding: 15px;
          border-radius: 15px;
          color: white;
          margin-left: auto;
          display: flex;
        "
        v-if="
          (esAdmin || esBodeguero) &&
          estado == 'Despachado' &&
          tipo == 'Retiro Bodega'
        "
        @click="anularDetalleRetiro()"
      >
        ANULAR ÍTEMS
      </v-btn>

      <v-btn
        style="
          width: 200px;
          background-color: #10510e;
          padding: 15px;
          border-radius: 15px;
          color: white;
          margin-left: 5px;
          display: flex;
        "
        v-if="esBodeguero && estado == 'Despachado'"
        @click="enviarRetiro()"
      >
        Enviar a BC365
      </v-btn>
    </div>
  </div>

  <v-row justify="center">
    <v-dialog v-model="dialogRechazar" persistent width="50%">
      <v-card>
        <v-card-title>
          <span class="text-h5"
            >¿Esta seguro que desea rechazar esta solicitud?</span
          >
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-textarea
                variant="solo"
                autocomplete="off"
                v-model="motivo"
                label="Motivo del rechazo*"
                required
              ></v-textarea>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue-darken-1"
            variant="text"
            @click="dialogRechazar = false"
          >
            No!
          </v-btn>
          <v-btn
            color="blue-darken-1"
            variant="text"
            @click="cambiarEstadoSolicitud('Rechazada')"
          >
            Si, rechazar!
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  <v-row justify="center">
    <v-dialog v-model="dialogAprobar" persistent width="50%">
      <v-card>
        <v-card-title>
          <span class="text-h5"
            >¿Esta seguro que desea aprobar esta solicitud?</span
          >
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-textarea
                variant="solo"
                v-model="motivo"
                autocomplete="off"
                label="Motivo del apruebo*"
                required
              ></v-textarea>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue-darken-1"
            variant="text"
            @click="dialogAprobar = false"
          >
            No!
          </v-btn>
          <v-btn
            color="blue-darken-1"
            variant="text"
            @click="cambiarEstadoSolicitud('Aprobada')"
          >
            Si, aprobar!
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  <v-row justify="center">
    <v-dialog v-model="dialogAutorizar" persistent width="50%">
      <v-card>
        <v-card-title>
          <span class="text-h5"
            >¿Esta seguro que desea autorizar esta solicitud?</span
          >
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-textarea
                variant="solo"
                v-model="motivo"
                label="Motivo de la autorizacion*"
                required
                autocomplete="off"
              ></v-textarea>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue-darken-1"
            variant="text"
            @click="dialogAutorizar = false"
          >
            No!
          </v-btn>
          <v-btn
            color="blue-darken-1"
            variant="text"
            @click="cambiarEstadoSolicitud('Autorizada')"
          >
            Si, autorizar!
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  <v-row justify="center">
    <v-dialog v-model="dialogDespachar" persistent width="50%">
      <v-card>
        <v-card-title>
          <span class="text-h5"
            >¿Esta seguro que desea despachar esta solicitud?</span
          >
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue-darken-1"
            variant="text"
            @click="dialogDespachar = false"
          >
            No!
          </v-btn>
          <v-btn
            color="blue-darken-1"
            variant="text"
            @click="despacharSolicitud()"
          >
            Si, despachar!
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  <v-row justify="center">
    <v-dialog v-model="dialogCerrar" persistent width="50%">
      <v-card>
        <v-card-title>
          <span class="text-h5"
            >¿Esta seguro que desea cerrar esta solicitud?</span
          >
        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue-darken-1"
            variant="text"
            @click="dialogCerrar = false"
          >
            No!
          </v-btn>
          <v-btn
            color="blue-darken-1"
            variant="text"
            @click="cerrarDespachado()"
          >
            Si!
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  <v-overlay
    :model-value="isLoading"
    class="align-center justify-center"
    persistent
  >
    <v-progress-circular
      color="#a61a2f"
      size="50"
      :width="5"
      indeterminate
    ></v-progress-circular>
  </v-overlay>

  <v-overlay
    :model-value="isLoadingEmail"
    class="align-center justify-center"
    persistent
  >
    <div>
      <v-progress-circular
        color="#a61a2f"
        size="50"
        :width="5"
        indeterminate
      ></v-progress-circular>

      <div
        style="
          margin-top: 10px;
          margin-left: -50px;
          font-size: 15px;

          color: #000000;
        "
      >
        <b>Validando Identidad</b>
      </div>
    </div>
  </v-overlay>
</template>

<script setup lang="ts">
import type { Ref } from "vue";
import { reactive, ref } from "vue";
import { onMounted } from "vue";
import { useStore } from "vuex";
import { key } from "@/store";
import axios from "axios";
import { useCookies } from "vue3-cookies";
import { useRouter, useRoute } from "vue-router";
import swal from "sweetalert2";
import { computed } from "vue";
import moment from "moment";
import { translateBcError } from "@/utils/errorTranslator";
import {
  isIngresoRespel,
  isRespelTipo,
  normalizeTipoSolicitud,
} from "@/utils/tipoSolicitudHelpers";

import type { SolicitudCompra } from "../types/solicitudCompra";
import type { Company } from "../types/company";
import type { Empleado } from "../types/empleado";
import type { DimensionCompany } from "../types/dimensionCompany";
import type { Adjunto } from "../types/adjunto";
import type { DepartamentoEmpleado } from "../types/departamentoEmpleado";
import type { SolicitudDetalle } from "../types/solicitudDetalle";
import type { Rol } from "../types/rol";
import type { PurchaseOrdersBody } from "../types/PurchaseOrdersBody";
import type { PurchaseOrderLine } from "../types/purchaseOrderLine";
import type { DimensionSetLine } from "../types/dimensionSetLine";
import type { Regularizacion } from "../types/regularizacion";
import type { Justificacion } from "../types/justificacion";
import type { Comprador } from "../types/comprador";
import type { ItemJournalLineResponseList } from "../types/ItemJournalLineResponseList";

import useComprador from "../composables/useComprador";
import useBodegas from "../composables/useBodega";
import useVendors from "../composables/useVendors";

const { cookies } = useCookies();
const store = useStore(key);
const router = useRouter();
const route = useRoute();

const idSol = computed(() => route.query.id as string | undefined);

const { getCompradores, lstCompradores } = useComprador();
const { getVendors, lstVendors } = useVendors();
const { getBodegas, lstBodegas } = useBodegas();

let isLoading: Ref<boolean> = ref(true);
let isLoadingEmail: Ref<boolean> = ref(false);

let idSolicitud: string = "";
let date: Ref<string> = ref("");
let fechaLiberacion: Ref<string> = ref("");
let code: Ref<number> = ref(0);
let obs: Ref<string> = ref("");
let solPorId: Ref<string> = ref("");
let solPorNombre: Ref<string> = ref("");

let lstEmpresas: Ref<Company[]> = ref([]);
let lstDimensions: Ref<DimensionCompany[]> = ref([]);

let empresaSel: Ref<string | null> = ref(null);
let departamentoSel: Ref<string | null> = ref(null);
let vendorSel: Ref<string | null> = ref(null);
let compradorSel: Ref<Comprador | null> = ref(null);
let bodegaSel: Ref<string | null> = ref(null);

let estado: Ref<string> = ref("");
let tipo: Ref<string> = ref("");
let solId: Ref<string> = ref("");
let solNombre: Ref<string> = ref("");
let nombreAutorizador: Ref<string> = ref("");
let motivo: Ref<string> = ref("");
let codigoDes: Ref<string> = ref("");
let idBc365: Ref<string> = ref("");
let enabledBC365: Ref<boolean> = ref(false);
let enabledRetiroBC365: Ref<boolean> = ref(false);
let esComprador: Ref<boolean> = ref(false);
let esAdmin: Ref<boolean> = ref(false);
let esBodeguero: Ref<boolean> = ref(false);
let esAutorizador: Ref<boolean> = ref(false);
let esContabilidad: Ref<boolean> = ref(false);
let esBodegaRespel: Ref<boolean> = ref(false);
let esAprobadorRespel: Ref<boolean> = ref(false);
let isUploadingFiles: Ref<boolean> = ref(false);
let aprobador: Ref<string> = ref("");
let dialogRechazar: Ref<boolean> = ref(false);
let dialogAprobar: Ref<boolean> = ref(false);
let dialogAutorizar: Ref<boolean> = ref(false);
let dialogDespachar: Ref<boolean> = ref(false);
let dialogCerrar: Ref<boolean> = ref(false);
let lstDetalle = reactive<SolicitudDetalle[]>([]);
let adjuntos: Adjunto[] = [];
let disabledCount: number = 0;
let total: Ref<number> = ref(0);
let usuario: Ref<Empleado | null> = ref(null);
let regSel: Ref<Regularizacion | null> = ref(null);
let justSel: Ref<Justificacion | null> = ref(null);
let autorizadorSel: Ref<string | null> = ref(null);
let descripOtro: Ref<string | null> = ref(null);
let enviadaPor: Ref<string | null> = ref(null);

let currentSolicitud: Ref<SolicitudCompra | null> = ref(null);
let isViveres: Ref<boolean> = ref(false);

let headers: any = [
  { title: "", key: "isSelected", width: "25px" },
  { title: "Id", key: "id", align: "center", width: "50px" },
  { title: "Cod", key: "codigoMaterial", align: "center", width: "150px" },
  {
    title: "Material/Servicio",
    key: "material",
    align: "center",
    width: "100px",
  },
  { title: "UN", key: "unidad", align: "center", width: "90px" },
  {
    title: "Fecha Límite",
    key: "fechaLimite",
    align: "center",
    width: "80px!important",
  },
  { title: "Q", key: "cantidad", align: "center", width: "100px" },
  { title: "Precio", key: "precio", align: "center", width: "100px" },
  { title: "Total", key: "total", align: "center", width: "100px" },
  { title: "Ceco", key: "cecoName", align: "start", width: "150px" },
  { title: "Proyecto", key: "proyectoName", align: "center", width: "150px" },
  { title: "Bodega", key: "bodegaName", align: "center", width: "100px" },
  {
    title: "Ped. Compra",
    key: "pedidoCompra",
    align: "center",
    width: "100px",
  },
  {
    title: "Estado",
    key: "estadoDespacho",
    align: "center",
    width: "100px!important",
  },
  {
    title: "OT Mantención",
    key: "otName",
    align: "center",
    width: "50px",
  },
  {
    title: "Mes servicio",
    key: "mesServicio",
    align: "center",
    width: "150px!important",
  },
  /*{
    title: "Concepto",
    key: "conceptoName",
    align: "center",
    width: "150px!important",
  },*/
];

let headersTripulanteViveres: any = [
  { title: "", key: "isSelected", width: "25px" },
  { title: "Id", key: "id", width: "25px" },
  {
    title: "Cod",
    key: "codigoMaterial",
    align: "center",
    width: "100px!important",
  },
  {
    title: "Material/Servicio",
    key: "material",
    align: "center",
    width: "300px",
  },
  { title: "UN", key: "unidad", align: "center" },
  {
    title: "Fecha Límite",
    key: "fechaLimite",
    align: "center",
    width: "80px!important",
  },
  { title: "Precio", key: "precio", align: "center", width: "150px!important" },
  { title: "Total", key: "total", align: "center", width: "100px!important" },
  { title: "Ceco", key: "cecoName", align: "center", width: "200px!important" },
  {
    title: "Proyecto",
    key: "proyectoName",
    align: "center",
    width: "250px!important",
  },
  {
    title: "Tripulante",
    key: "tripulanteName",
    align: "center",
    width: "225px!important",
  },
  {
    title: "Turno",
    key: "turnoName",
    align: "center",
    width: "225px!important",
  },
  {
    title: "Fecha Compra",
    key: "fechaCompra",
    align: "center",
    width: "220px!important",
  },
  {
    title: "Estado",
    key: "estadoDespacho",
    align: "center",
    width: "100px!important",
  },
  {
    title: "Fecha Término",
    key: "fechaTermino",
    align: "center",
    width: "220px!important",
  },
  // {
  //   title: "Mes servicio",
  //   key: "mesServicio",
  //   align: "center",
  //   width: "150px!important",
  // },
  /*{
    title: "Tiene Presupuesto",
    key: "tienePresup",
    align: "center",
    width: "50px!important",
  },
  {
    title: "Concepto",
    key: "concepto",
    align: "center",
    width: "300px!important",
  },*/
  { title: "", key: "actions", align: "center", width: "25px" },
];

let headersRetiro: any = [
  { title: "", key: "isSelected", width: "25px" },
  { title: "Id", key: "id", align: "center", width: "25px" },
  { title: "Cod", key: "codigoMaterial", align: "center", width: "150px" },
  {
    title: "Material/Servicio",
    key: "material",
    align: "start",
    width: "200px",
  },
  {
    title: "Inventario",
    key: "inventario",
    align: "center",
    width: "50px",
  },
  { title: "N° Serie", key: "numSerie", align: "center", width: "150px" },
  { title: "UN", key: "unidad", align: "center", width: "90px" },
  { title: "Q", key: "cantidad", align: "center", width: "100px" },
  { title: "Ceco", key: "cecoName", align: "start", width: "100px" },
  { title: "Proyecto", key: "proyectoName", align: "center", width: "200px" },
  {
    title: "Estado",
    key: "estadoDespacho",
    align: "center",
    width: "100px",
  },
  {
    title: "OT Mantención",
    key: "otName",
    align: "center",
    width: "50px",
  },
  {
    title: "Cantidad a Retirar",
    key: "cantidadRetirar",
    align: "center",
    width: "100px",
  },
  {
    title: "Adjunto",
    key: "chosenFile",
    align: "center",
    width: "150px",
  },
  {
    title: "Observación",
    key: "codigoDespacho",
    align: "center",
    width: "100px",
  },
  { title: "", key: "actions", align: "center", width: "100px" },
];

let headersRendicion: any = [
  { title: "Id", key: "id", width: "25px" },
  { title: "Tipo Docto", key: "tipoDoc", align: "center" },
  { title: "N° Docto", key: "nroDoc", align: "center" },
  { title: "Fecha Docto", key: "fechaDoc", align: "center" },
  { title: "Proveedor", key: "vendorName", align: "center" },
  { title: "Material/Servicio", key: "material", align: "center" },
  { title: "Descripción del Gasto", key: "descGasto", align: "center" },
  { title: "Ceco", key: "cecoName", align: "center", width: "250px" },
  {
    title: "Proyecto",
    key: "proyectoName",
    align: "center",
    width: "250px",
  },
  { title: "Monto", key: "monto", align: "center", width: "150px" },
  {
    title: "OT Mantención",
    key: "otName",
    align: "center",
    width: "50px",
  },
];

let headersResiduo: any = [
  { title: "Id", key: "id", align: "center", width: "50px" },
  { title: "Cod", key: "codigoMaterial", align: "center", width: "150px" },
  {
    title: "Material/Servicio",
    key: "material",
    align: "center",
    width: "300px",
  },
  { title: "UN", key: "unidad", align: "center", width: "90px" },
  { title: "Cantidad", key: "cantidad", align: "center", width: "120px" },
  { title: "Ceco", key: "cecoName", align: "center", width: "200px" },
  { title: "Bodega", key: "bodegaName", align: "center", width: "200px" },
  {
    title: "Tipo Residuo",
    key: "tipoResiduo",
    align: "center",
    width: "200px",
  },
];

let computedHeadersResiduo = computed(() => {
  if (tipo.value === "Retiro RESPEL") {
    // Retiro RESPEL muestra todo excepto tipoResiduo
    return headersResiduo.filter((h: any) => h.key !== "tipoResiduo");
  } else if (tipo.value === "Ingreso RESPEL") {
    // Ingreso RESPEL muestra todo excepto bodegaName
    return headersResiduo.filter((h: any) => h.key !== "bodegaName");
  }
  return headersResiduo;
});

let lstRegularizacion: Regularizacion[] = [
  { id: "Si", nombre: "Si" },
  { id: "No", nombre: "No" },
];

let lstJustificacion: Justificacion[] = [
  { id: 1, nombre: "Adicionales" },
  { id: 2, nombre: "No planificado" },
  { id: 3, nombre: "Urgencia" },
  { id: 4, nombre: "Corrección tipo cambio" },
  { id: 5, nombre: "Regularización Autorizada por" },
  { id: 6, nombre: "Servicio recurrente, trabaja sin SOC" },
  { id: 7, nombre: "Otro justificar" },
];

onMounted(async () => {
  try {
    store.state.titulo = "Detalle Solicitud";

    await getCompanies();
    // sendEmail("1558b68e-62ce-4719-8e42-1f7eef2f90e8");
  } catch (error) {
    console.log(error);
  } finally {
    setTimeout(() => {
      isLoading.value = false;
    }, 1000);
  }
});

async function obtenerEmpleado(email: string) {
  try {
    isLoading.value = true;

    await axios
      .get(store.state.url + "api/Empleado/GetEmpleadoXEmail?email=" + email, {
        headers: {},
      })
      .then(async (response) => {
        if (response.status == 200) {
          usuario.value = response.data;
          // autorizador.value = response.data.rut;
        } else {
          console.log(response.statusText);
        }
      })
      .catch(function (error) {
        console.log(error.message);
      });
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
}

function getSolicitudCompra() {
  isLoading.value = true;

  try {
    axios
      .get(
        store.state.url +
          "api/SolicitudCompra/GetSolicitudCompra?solicitudId=" +
          idSol.value, //route.params.solicitudId
      )
      .then(async (response) => {
        if (response.status == 200) {
          currentSolicitud.value = response.data as SolicitudCompra;
          var solicitud: SolicitudCompra = response.data as SolicitudCompra;

          // console.log(solicitud);

          let validarUsuario = await verificarUsuario(
            solicitud.encabezado.tipoSolicitudId || "",
            solicitud.encabezado.departamentoId || "",
            solicitud.encabezado.solicitantePorId || "",
            solicitud.encabezado.solicitanteId || "",
          );
          if (!validarUsuario) {
            swal.fire({
              title: "Error",
              text: "No tiene permisos para ver esta solicitud",
              icon: "error",
              confirmButtonText: "Aceptar",
            });

            router.push({ name: "BuscaSolicitud" });
            return;
          }

          await getCompradores(
            currentSolicitud.value.encabezado.companyId || "",
          );

          // Cargar vendors y bodegas para búsqueda en tipos RESPEL
          await getVendors(currentSolicitud.value.encabezado.companyId || "");

          await getBodegas(currentSolicitud.value.encabezado.companyId || "");

          estado.value = solicitud.encabezado.estado || "";
          tipo.value =
            normalizeTipoSolicitud(solicitud.encabezado.tipoSolicitudId) || "";

          idSolicitud = solicitud.encabezado.id || "";
          date.value = solicitud.encabezado.fechaSolicitud?.substr(0, 10) || "";
          fechaLiberacion.value =
            solicitud.encabezado.fechaLiberacion?.substr(0, 10) || "";
          solPorId.value = solicitud.encabezado.solicitantePorId || "";
          solPorNombre.value = solicitud.encabezado.solicitantePorNombre || "";
          code.value = solicitud.encabezado.code || 0;

          empresaSel.value = solicitud.encabezado.companyName || null;
          departamentoSel.value = solicitud.encabezado.departamentoName || null;

          if (solicitud.encabezado.vendorName == null) {
            vendorSel.value = "PROVEDOR YA NO EXISTE";
          } else {
            vendorSel.value = solicitud.encabezado.vendorName || null;
          }

          // vendorSel.value = solicitud.encabezado.vendorName || null;
          // compradorSel.value = solicitud.encabezado.compradorName || null;

          compradorSel.value =
            lstCompradores.value.find(
              (c) => c.code == solicitud.encabezado.comprador,
            ) || null;

          solId.value = solicitud.encabezado.solicitanteId || "";
          solNombre.value = solicitud.encabezado.solicitanteNombre || "";
          obs.value = solicitud.encabezado.observacion || "";

          if (
            estado.value == "Autorizada" ||
            estado.value == "Aprobada" ||
            estado.value == "Rechazada" ||
            estado.value == "Enviada" ||
            estado.value == "En Envio" ||
            estado.value == "En Despacho" ||
            estado.value == "Despachado" ||
            (estado.value == "Enviada" &&
              solicitud.encabezado.autorizadorId != null)
          ) {
            nombreAutorizador.value = solicitud.encabezado.autorizador || "";
            motivo.value = solicitud.encabezado.motivo || "";
          }

          enviadaPor.value = solicitud.encabezado.enviadoPorNombre || "";

          adjuntos = (await getFiles(idSolicitud)) || [];

          solicitud.detalle.forEach((det) => {
            let detalle: SolicitudDetalle = {};
            // // console.log(det.fechaLimite);

            if (tipo.value == "Compra") {
              if (det.codigoMaterial == "SER-410102") {
                isViveres.value = true;
              } else {
                isViveres.value = false;
              }

              // det.fechaLimite = det.fechaLimite?.substr(0, 10) || "";

              idBc365.value = solicitud.encabezado.bC365Id || "";

              if (solicitud.encabezado.solRegularizacion) {
                regSel.value =
                  lstRegularizacion.find((r) => r.id == "Si") || null;
              } else {
                regSel.value =
                  lstRegularizacion.find((r) => r.id == "No") || null;
              }

              if (solicitud.encabezado.justificacion != null) {
                justSel.value =
                  lstJustificacion.find(
                    (j) => j.nombre == solicitud.encabezado.justificacion,
                  ) || null;
              }

              autorizadorSel.value =
                solicitud.encabezado.autorizadorJustificacionNombre || null;
              descripOtro.value = solicitud.encabezado.otraJustificacion || "";

              detalle = {
                id: det.id,
                codigoMaterial: det.codigoMaterial,
                material: det.material,
                unidad: det.unidad,
                cantidad: det.cantidad,
                precio: det.precio,
                total: det.total,
                mesServicio: det.mesServicio,
                pedidoCompra: det.pedidoCompra,
                cecoName: det.cecoName,
                proyectoName: det.proyectoName,
                bodegaName: det.bodegaName,
                otName: det.otName,
                cecoId: det.cecoId,
                idItem: det.idItem,
                tripulanteName: det.tripulanteName,
                turnoName: det.turnoName,
                fechaCompra: det.fechaCompra?.substr(0, 10),
                fechaTermino: det.fechaTermino?.substr(0, 10),
                fechaLimite: det.fechaLimite?.substr(0, 10),
                estadoDespacho: det.estadoDespacho,
                // isSelected:
                //   det.estadoDespacho == "Enviada" ||
                //   det.estadoDespacho == "Anulada",
                // conceptoName: det.conceptoName,
              };
            }

            if (tipo.value == "Retiro Bodega") {
              codigoDes.value = solicitud.encabezado.codigoDespacho || "";
              bodegaSel.value = solicitud.encabezado.bodegaName || null;

              codigoDes.value = solicitud.encabezado.codigoDespacho || "";

              detalle = {
                id: det.id,
                encabezadoId: det.encabezadoId,
                codigoMaterial: det.codigoMaterial,
                material: det.material,
                unidad: det.unidad,
                cantidad: det.cantidad,
                cecoName: det.cecoName,
                proyectoName: det.proyectoName,
                otName: det.otName,
                codigoDespacho: det.codigoDespacho,
                idItem: det.idItem,
                retiroBodega: det.retiroBodega,
                adjuntoRetiro: det.adjuntoRetiro,
                numSerie: det.numSerie,
                inventario: det.inventario,
                estadoDespacho: det.estadoDespacho,
              };

              // if (estado.value == "Despachado") {
              //   detalle.cantidadRetirar = det.cantidad;
              // }

              // if (estado.value == "Enviada") {
              detalle.cantidadRetirar =
                (det.cantidad ?? 0) - (det.cantidadRetirar ?? 0);
              // }
            }

            if (tipo.value == "Rendicion") {
              detalle = {
                id: det.id,
                tipoDoc: det.tipoDoc,
                nroDoc: det.nroDoc,
                fechaDoc: det.fechaDoc?.substr(0, 10),
                vendorName: det.vendorName,
                material: det.material,
                descGasto: det.descGasto,
                cecoName: det.cecoName,
                proyectoName: det.proyectoName,
                monto: det.monto,
                otName: det.otName,
                idItem: det.idItem,
              };
            }

            if (tipo.value == "Retiro RESPEL") {
              codigoDes.value = solicitud.encabezado.codigoDespacho || "";

              // Buscar el nombre legible de la bodega en lstBodegas
              const bodegaEncontrada = lstBodegas.value.find(
                (b) => b.id == solicitud.encabezado.codigoBodega,
              );
              bodegaSel.value =
                bodegaEncontrada?.codeDisplayName ||
                solicitud.encabezado.codigoBodega ||
                "";

              detalle = {
                id: det.id,
                codigoMaterial: det.codigoMaterial,
                material: det.material,
                unidad: det.unidad,
                cantidad: det.cantidad,
                cecoId: det.cecoId,
                cecoName: det.cecoName,
                tipoResiduo: det.tipoResiduo,
                idItem: det.idItem,
              };
            }

            if (isIngresoRespel(tipo.value)) {
              detalle = {
                id: det.id,
                codigoMaterial: det.codigoMaterial,
                material: det.material,
                unidad: det.unidad,
                cantidad: det.cantidad,
                cecoId: det.cecoId,
                cecoName: det.cecoName,
                tipoResiduo: det.tipoResiduo,
                idItem: det.idItem,
              };
            }

            lstDetalle.push(detalle);
          });

          if (tipo.value == "Compra") {
            lstDetalle.map((item) => {
              if (item.estadoDespacho == "Enviada") {
                disabledCount += 1;
              }

              // if (item.codigoMaterial == "SER-410102") {
              //   isViveres.value = true;
              // } else {
              //   isViveres.value = false;
              // }
            });

            compraTotal();
          } else {
            rendicionTotal();
            //console.log(total);
          }

          var roles = await getRol(cookies.get("username"));
          // var roles = await getRol("czambrano@oxxeanchile.cl");

          if (currentSolicitud.value.encabezado.departamentoCode != null) {
            var rolDepto = await getRolDepto(
              cookies.get("username"),
              // "czambrano@oxxeanchile.cl",
              currentSolicitud.value.encabezado.departamentoCode || "",
            );

            if (rolDepto != null && roles != null) {
              if (
                roles.some((r: Rol) => r.rolNombre === "Aprobador") &&
                rolDepto.some((r) => r.rolEmail === "Aprobador") &&
                tipo.value != "Rendicion"
              ) {
                aprobador.value = "Aprobador";
              } else {
                if (
                  roles.some((r: Rol) => r.rolNombre === "Autorizador") &&
                  rolDepto.some((r) => r.rolEmail === "Autorizador") &&
                  tipo.value == "Rendicion"
                ) {
                  aprobador.value = "Autorizador";
                }
              }

              // marcar si el usuario tiene rol Aprobador RESPEL para el depto de la orden (Ingreso RESPEL)
              if (
                roles.some((r: Rol) => r.rolNombre === "Aprobador RESPEL") &&
                rolDepto.some((r) => r.rolEmail === "Aprobador RESPEL") &&
                isIngresoRespel(tipo.value)
              ) {
                esBodegaRespel.value = true;
              }

              // marcar si el usuario tiene rol Aprobador RESPEL para el depto de la orden (Retiro RESPEL)
              if (
                roles.some((r: Rol) => r.rolNombre === "Aprobador RESPEL") &&
                rolDepto.some((r) => r.rolEmail === "Aprobador RESPEL") &&
                tipo.value === "Retiro RESPEL"
              ) {
                esAprobadorRespel.value = true;
              }
            }
          }

          if (
            roles != null &&
            roles.some((r) => r.rolNombre === "Administrator")
          ) {
            esAdmin.value = true;
          }

          if (tipo.value == "Compra") {
            if (
              (estado.value == "Creada" ||
                estado.value == "Aprobada" ||
                estado.value == "En Envio") &&
              roles != null &&
              roles.some((r) => r.rolNombre === "Comprador")
            ) {
              esComprador.value = true;
            }
          } else {
            if (tipo.value == "Retiro Bodega") {
              if (
                estado.value == "Aprobada" &&
                roles != null &&
                roles.some((r) => r.rolNombre === "Bodega")
              ) {
                esBodeguero.value = true;
              }

              if (
                (estado.value == "En Despacho" ||
                  estado.value == "Despachado") &&
                roles != null &&
                roles.some((r) => r.rolNombre === "Bodega")
              ) {
                esBodeguero.value = true;
              }

              // verificar que en todos los elementos de lstDetalle la cantidadRetirar sea 0
              // if (
              //   lstDetalle.filter((d) => d.cantidadRetirar != 0).length == 0 &&
              //   estado.value == "Despachado"
              // ) {
              //   dialogCerrar.value = true;
              // }
            } else {
              if (tipo.value == "Rendicion") {
                if (
                  estado.value == "Creada" &&
                  roles != null &&
                  roles.some((r) => r.rolNombre === "Autorizador")
                ) {
                  esAutorizador.value = true;
                } else {
                  if (
                    estado.value == "Autorizada" &&
                    roles != null &&
                    roles.some((r) => r.rolNombre === "Contabilidad")
                  ) {
                    esContabilidad.value = true;
                  }
                }
              }
            }
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });

    isLoading.value = false;
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
}

async function getDeptosRol(email: string, rol: string) {
  try {
    var deptos: string[] = [];

    await axios
      .get(
        store.state.url + "api/Rol/GeDeptostRol?email=" + email + "&rol=" + rol,
        {
          headers: {},
        },
      )
      .then((response) => {
        if (response.status == 200) {
          deptos = response.data;
        } else {
          console.log(response.statusText);
        }
      })
      .catch(function (error) {
        console.log(error.message);
      });

    return deptos;
  } catch (error) {
    console.log(error);
  }
}

async function verificarUsuario(
  tipo: string,
  depto: string,
  solPorId: string,
  solId: string,
) {
  let verificado = false;

  await obtenerEmpleado(cookies.get("username"));
  // await this.obtenerEmpleado("czambrano@oxxeanchile.cl");

  var roles = await getRol(cookies.get("username"));
  // var roles = await this.getRol("czambrano@oxxeanchile.cl");

  if (roles != null && roles.some((r) => r.rolNombre === "Administrador")) {
    return true;
  }

  if (usuario != null && usuario.value?.rut == solId) {
    return true;
  }

  if (usuario != null && usuario.value?.rut == solPorId) {
    return true;
  }

  if (
    tipo == "Compra" &&
    roles != null &&
    roles.some((r) => r.rolNombre === "Comprador")
  ) {
    verificado = true;
  }

  if (
    tipo == "Retiro Bodega" &&
    roles != null &&
    roles.some((r) => r.rolNombre === "Bodega")
  ) {
    verificado = true;
  }

  if (
    tipo == "Rendicion" &&
    roles != null &&
    roles.some((r) => r.rolNombre === "Contabilidad")
  ) {
    verificado = true;
  }

  if (
    (tipo == "Compra" || tipo == "Retiro Bodega") &&
    roles != null &&
    roles.some((r) => r.rolNombre === "Visualizador")
  ) {
    let deptosViusalizador = await getDeptosRol(
      cookies.get("username"),
      // "czambrano@oxxeanchile.cl",
      "Visualizador",
    );

    if (deptosViusalizador?.some((d) => d == depto)) {
      verificado = true;
    }
  }

  if (
    tipo == "Rendicion" &&
    roles != null &&
    roles.some((r) => r.rolNombre === "Autorizador")
  ) {
    let deptosAutorizador = await getDeptosRol(
      cookies.get("username"),
      // "czambrano@oxxeanchile.cl",
      "Autorizador",
    );

    if (deptosAutorizador?.some((d) => d == depto)) {
      verificado = true;
    }
  }

  if (
    tipo == "Rendicion" &&
    roles != null &&
    roles.some((r) => r.rolNombre === "Visor Rendiciones")
  ) {
    verificado = true;
  }

  if (
    (tipo == "Compra" || tipo == "Retiro Bodega") &&
    roles != null &&
    roles.some((r) => r.rolNombre === "Aprobador")
  ) {
    let deptosAprobador = await getDeptosRol(
      (roles != null && cookies.get("username")) || "",
      // "czambrano@oxxeanchile.cl",
      "Aprobador",
    );

    if (deptosAprobador?.some((d) => d == depto)) {
      verificado = true;
    }
  }

  if (
    isRespelTipo(tipo) &&
    roles != null &&
    roles.some((r) => r.rolNombre === "Aprobador RESPEL")
  ) {
    let deptosAprobadorRespel = await getDeptosRol(
      cookies.get("username"),
      "Aprobador RESPEL",
    );

    if (deptosAprobadorRespel?.some((d) => d == depto)) {
      verificado = true;
    }
  }

  return verificado;
}

async function enviarBusinessCentral() {
  try {
    await getDimensionsLines();

    enabledBC365.value = false;

    if (vendorSel.value == "PROVEDOR YA NO EXISTE") {
      swal.fire({
        icon: "error",
        title: "Error al enviar a Business Central",
        text: "El proveedor de la solicitud ya no existe en Business Central, por favor contacte a su administrador",
      });

      enabledBC365.value = true;
      return;
    }

    if (vendorSel.value == null) {
      swal.fire({
        icon: "error",
        title: "Error al enviar a Business Central",
        text: "Debe seleccionar un proveedor",
      });

      enabledBC365.value = true;
      return;
    }

    if (
      lstDetalle.filter((d) => d.estadoDespacho != "Enviada" && d.isSelected)
        .length == 0
    ) {
      swal.fire({
        icon: "error",
        title: "Error al enviar a Business Central",
        text: "Debe seleccionar al menos un Item",
      });

      enabledBC365.value = true;
      return;
    }

    var purchaseOrdersBody: PurchaseOrdersBody = {
      orderDate: date.value,
      postingDate: date.value,
      vendorId: currentSolicitud.value?.encabezado.proveedorId || "",
      vendorNumber: currentSolicitud.value?.encabezado.vendorNumber || "",
      payToVendorId: currentSolicitud.value?.encabezado.proveedorId || "",
      payToVendorNumber: currentSolicitud.value?.encabezado.vendorNumber || "",
      buyFromAddressLine1: "",
      buyFromAddressLine2: "",
      buyFromCity: "",
      buyFromCountry: "",
      currencyId: "00000000-0000-0000-0000-000000000000",
      currencyCode: "CLP",
      pricesIncludeTax: false,
      paymentTermsId: currentSolicitud.value?.encabezado.paymentTermsId || "", //vendorSel.value.paymentTermsId,
      shipmentMethodId: "00000000-0000-0000-0000-000000000000",
      requestedReceiptDate: "0001-01-01",
      discountAmount: 0,
      fullyReceived: false,
      shipToCity: "",
      shipToName: "",
      shipToState: "",
      buyFromState: "",
      shipToContact: "",
      shipToCountry: "",
      shipToPostCode: "",
      buyFromPostCode: "",
      shipToAddressLine1: "",
      shipToAddressLine2: "",
      shortcutDimension1Code: "",
      shortcutDimension2Code: "",
      purchaser: currentSolicitud.value?.encabezado.comprador || "", //compradorSel.value?.code || "",
      purchaseOrderLines: [],
      dimensionSetLines: [],
      axx_Applicant: currentSolicitud.value?.encabezado.solicitanteNombre || "",
    };

    //console.log(JSON.stringify(purchaseOrdersBody));

    var validaItems : ValidaItem[] = [];

    for (var det of lstDetalle.filter(
      (d) =>
        (d.retiroBodega == false || d.retiroBodega == null) &&
        d.estadoDespacho != "Enviada" &&
        d.isSelected,
    )) {
      let row = currentSolicitud.value?.detalle.find((d) => d.id == det.id);

      let lines: PurchaseOrderLine = {
        lineNumber: det.id,
        itemId: det.idItem || "",
        quantity: det.cantidad || 0,
        directUnitCost: det.precio || 0,
        dimensionSetLines: [
          {
            id:
              lstDimensions.value.filter((d) => d.dimensionName == "CECO")[0]
                .dimensionId || "",
            valueId: row?.cecoId, //ceco?.id || "",
          },
          {
            id:
              lstDimensions.value.filter((d) => d.dimensionName == "DPTO")[0]
                .dimensionId || "",
            valueId: currentSolicitud.value?.encabezado.departamentoId, //departamentoSel.value?.id || "",
          },
        ],
      } as PurchaseOrderLine;

      if (row?.proyectoId != null) {
        lines.dimensionSetLines?.push({
          id:
            lstDimensions.value.filter((d) => d.dimensionName == "PROYECTO")[0]
              .dimensionId || "",
          valueId: row?.proyectoId,
        });
      }

      if (row?.otMantencion != null) {
        lines.dimensionSetLines?.push({
          id:
            lstDimensions.value.filter((d) => d.dimensionName == "AUX_NDOC")[0]
              .dimensionId || "",
          valueId: row?.otMantencion,
        });
      }

      if (row?.tripulanteId != null) {
        lines.dimensionSetLines?.push({
          id:
            lstDimensions.value.filter(
              (d) => d.dimensionName == "TRIPULANTE",
            )[0].dimensionId || "",
          valueId: row?.tripulanteId,
        });
      }

      if (row?.turnoId != null) {
        lines.dimensionSetLines?.push({
          id:
            lstDimensions.value.filter((d) => d.dimensionName == "TURNO")[0]
              .dimensionId || "",
          valueId: row?.turnoId,
        });
      }

      // // if (det.otMantencion != null) {
      // //   // // await getAuxNdoc(currentSolicitud.value?.encabezado.companyId || "");

      // //   lines.dimensionSetLines?.push({
      // //     id:
      // //       lstDimensions.value.filter((d) => d.dimensionName == "AUX_NDOC")[0]
      // //         .dimensionId || "",
      // //     valueId:
      // //       lstAuxNdoc.value.find((a) => a.displayName == det.otMantencion)
      // //         ?.id || "",
      // //   });
      // // }

      validaItems.push({
        line: row?.id || null,
        id: row?.idItem || null,
        code: row?.codigoMaterial || null,
      });

      purchaseOrdersBody.purchaseOrderLines?.push(lines);
    }

    let comment: PurchaseOrderLine = {
      lineType: "Comment",
      description: "SOC-" + code.value.toString().padStart(7, "0"),
    } as PurchaseOrderLine;

    purchaseOrdersBody.purchaseOrderLines?.push(comment);

    if (
      purchaseOrdersBody.dimensionSetLines?.some(
        (d: DimensionSetLine) =>
          d.id ==
          lstDimensions.value.filter((dl) => dl.dimensionName == "DPTO")[0]
            .dimensionId,
      ) == false
    ) {
      purchaseOrdersBody.dimensionSetLines.push({
        id:
          lstDimensions.value.filter((d) => d.dimensionName == "DPTO")[0]
            .dimensionId || "",
        valueId: currentSolicitud.value?.encabezado.departamentoId || "",
      });
    }

    isLoading.value = true;

    var postPurchaseOrderRequest: PostPurchaseOrderRequest = {
      purchaseOrdersBody,
      validaItems,
    }; 

    await axios
      .post(
        store.state.url +
          "api/SolicitudCompra/PostPurchaseOrder?company=" +
          currentSolicitud.value?.encabezado.companyId + //empresaSel.value?.id +
          "&idSol=" +
          idSolicitud +
          "&usuario=" +
          usuario.value?.rut, //autorizador,
        postPurchaseOrderRequest,
      )
      .then((response) => {
        if (response.status == 200 && response.data.number != null) {
          // // // console.log(response);
          // if (
          //     lstDetalle.filter((d) => d.isSelected).length == lstDetalle.length
          //   ) {
          //     cambiarEstadoSolicitud("Enviada");
          //   } else {
          //     cambiarEstadoSolicitud("En Envio");
          //   }

          estado.value = "Enviada";
          console.log("Solicitud Enviada a Business Central Exitosa");

          // dialogAprobar = false;

          swal.fire({
            icon: "success",
            title: "Solicitud Enviada a Business Central Exitosa",
            showConfirmButton: false,
            timer: 2000,
          });

          router.push({ name: "BuscaSolicitud" });
        } else {
          console.log("error al enviar: " + response.data.error.message);
          const t = translateBcError(response.data.error.message); // { message, correlationId, key }

          swal.fire({
            icon: "error",
            title: "Error al enviar a Business Central",
            text: t.message, //response.data.error.message,
          });
        }
      })
      .catch((error) => {
        // errorMessage = error.message;
        console.error("There was an error!", error);
        const t = translateBcError(error); // { message, correlationId, key }

        swal.fire({
          icon: "error",
          title: "Error al enviar a Business Central",
          text: t.message, //error.message,
        });
      })
      .finally(() => {
        dialogAprobar.value = false;
        isLoading.value = false;
        enabledBC365.value = true;
      });
  } catch (error) {
    // errorMessage = error.message;
    console.error("There was an error!", error);
  } finally {
    isLoading.value = false;
    enabledBC365.value = true;
  }
}

async function enviarRendicion() {
  var errorMsg: string[] = [];
  var enviadas = [];

  enabledBC365.value = false;
  isLoading.value = true;

  await axios
    .post(
      store.state.url +
        "api/Rendicion/EnviarRendicion?rendicionId=" +
        idSolicitud +
        "&company=" +
        currentSolicitud.value?.encabezado.companyId + //empresaSel.value?.id +
        "&usuario=" +
        usuario.value?.rut, //autorizador.value
    )
    .then(async (response) => {
      if (response.status == 200) {
        for (var res of response.data) {
          if (res.message.includes("error")) {
            errorMsg.push(res.message + "\n\n");
          } else {
            enviadas.push(res.solicitudId);
          }
        }

        if (errorMsg.length > 0) {
          // swal.fire({
          //   icon: "error",
          //   title: "Error al enviar a Business Central",
          //   text: errorMsg.join(),
          // });
          showMultipleErrors(errorMsg.map((msg) => ({ message: msg })));
        } else {
          if (response.data.length == 0) {
            swal.fire({
              icon: "success",
              title: "Rendiciones enviadas correctamente",
              text:
                "Se enviaron detalle(s) de la solicitud SOC-" +
                code.value.toString().padStart(7, "0"),
            });
            return;
          } else {
            console.log("Solicitudes enviadas correctamente");

            estado.value = "Enviada";

            // swal.fire({
            //   icon: "success",
            //   title: "Rendiciones enviadas correctamente",
            //   text:
            //     "Se enviaron " +
            //     enviadas.length +
            //     " detalle(s) de la solicitud SOC-" +
            //     code.value.toString().padStart(7, "0"),
            // });

            swal.fire({
              icon: "success",
              title: "Rendiciones enviadas correctamente",
              text:
                "Se envio exitosamente a Business Central la solicitud SOC-" +
                code.value.toString().padStart(7, "0"),
            });
          }

          router.push({ name: "BuscaSolicitud" });
        }
      } else {
        console.log(response.statusText);
        const t = translateBcError(response.statusText); // { message, correlationId, key }

        swal.fire({
          icon: "error",
          title: "Error al enviar Rendición a Business Central",
          text: t.message, //response.statusText,
        });
      }
    })
    .catch((error) => {
      //errorMessage = error.message;
      console.error("There was an error!", error);

      const t = translateBcError(error.message); // { message, correlationId, key }

      swal.fire({
        icon: "error",
        title: "Error al enviar Rendición a Business Central",
        text: t.message,
      });
    })
    .finally(() => {
      isLoading.value = false;
      enabledBC365.value = true;
    });
}

function getCompanies() {
  try {
    axios
      .get(store.state.url + "api/Company/GetCompanies", { headers: {} })
      .then(async (response) => {
        if (response.status == 200) {
          lstEmpresas.value = response.data as Company[];
          // isLoading.value = true;

          getSolicitudCompra();
        } else {
          console.log(response.statusText);
        }
      })
      .catch(function (error) {
        console.log(error.message);
      });
  } catch (error) {
    console.log(error);
  }
}

async function getDimensionsLines() {
  try {
    if (empresaSel.value == null) {
      return;
    }

    await axios
      .get(
        store.state.url +
          "api/SolicitudCompra/GetDimensionsId?company=" +
          currentSolicitud.value?.encabezado.companyId, //empresaSel.value.id,
        {
          headers: {},
        },
      )
      .then((response) => {
        if (response.status == 200) {
          lstDimensions.value = response.data as DimensionCompany[];
        } else {
          console.log(response.statusText);
        }
      })
      .catch(function (error) {
        console.log(error.message);
      });
  } catch (error) {}
}

async function getFiles(idSolicitud: string) {
  try {
    var archivos: Adjunto[] = [];

    await axios
      .get(
        store.state.url +
          "api/SolicitudCompra/GetSolicitudFiles?solicitudId=" +
          idSolicitud,
      )
      .then((response) => {
        if (response.status == 200) {
          archivos = response.data;
        } else {
          console.log(response.statusText);
        }
      })
      .catch(function (error) {
        console.log(error.message);
      });

    return archivos;
  } catch (error) {
    console.log(error);
  }
}

function updateComprador() {
  try {
    if (compradorSel.value == null) {
      swal.fire({
        icon: "error",
        title: "Error al actualizar comprador",
        text: "Debe seleccionar un comprador",
      });

      return;
    }

    isLoading.value = true;

    axios
      .put(
        store.state.url +
          "api/SolicitudCompra/UpdateComprador?id=" +
          idSolicitud +
          "&compradorId=" +
          compradorSel.value.code,
      )
      .then((response) => {
        if (response.status == 200) {
          console.log("comprador actualizado Exitosamente");

          currentSolicitud.value!.encabezado.comprador =
            compradorSel.value?.code;

          swal.fire({
            icon: "success",
            title: "Comprador actualizado",
            showConfirmButton: false,
            timer: 2000,
          });
        }
      })
      .catch((error) => {
        // errorMessage = error.message;
        console.error(error.message);
      });
  } catch (error) {
    // errorMessage = error.message;
    console.error("There was an error!", error);
  } finally {
    isLoading.value = false;
  }
}

async function getRolDepto(email: string, depto: string) {
  try {
    var tiene: DepartamentoEmpleado[] | null = [];

    await axios
      .get(
        store.state.url +
          "api/Rol/GetRolDepto?email=" +
          email +
          "&depto=" +
          depto,
        {
          headers: {},
        },
      )
      .then((response) => {
        if (response.status == 200) {
          //tieneRol = response.data;
          //console.log(response.data);
          tiene = response.data;
        } else {
          console.log(response.statusText);
          tiene = null;
        }
      })
      .catch(function (error) {
        console.log(error.message);
        tiene = null;
      });

    return tiene;
  } catch (error) {
    console.log(error);
  }
}

function bajarAdjunto(filename: string) {
  try {
    isLoading.value = true;

    const link = document.createElement("a");
    link.href =
      store.state.url + "api/SolicitudCompra/DownloadFile?fileName=" + filename;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
}

async function getRol(email: string) {
  try {
    var tiene: Rol[] = [];

    await axios
      .get(store.state.url + "api/Rol/GetRol?email=" + email, {
        headers: {},
      })
      .then((response) => {
        if (response.status == 200) {
          tiene = response.data as Rol[];
        } else {
          console.log(response.statusText);
          tiene = [];
        }
      })
      .catch(function (error) {
        console.log(error.message);
        tiene = [];
      });

    return tiene;
  } catch (error) {
    console.log(error);
  }
}

function despacharItem(despachado: SolicitudDetalle) {
  if (despachado.codigoDespacho == "") {
    swal.fire({
      icon: "error",
      title: "Error al despachar",
      text: "Debe ingresar un codigo de despacho",
    });

    return;
  }

  try {
    axios
      .put(
        store.state.url +
          "api/SolicitudCompra/DespacharItem?usuario=" +
          usuario.value?.rut, //autorizador.value,
        despachado,
        { headers: { "Content-Type": "application/json" } },
      )
      .then((response) => {
        if (response.status == 200) {
          var res = response.data;

          // console.log(res);
          if (res.estado == "Despachado") {
            despachado.estadoDespacho = "Despachado";
            estado.value = "Despachado";
            codigoDes.value = res.codigoDespacho;

            router.push({ name: "BuscaSolicitud" });
          } else {
            despachado.estadoDespacho = "Despachado";
            estado.value = "En Despacho";
            codigoDes.value = res.codigoDespacho;
          }

          console.log("Item despachado Exitosamente");

          swal.fire({
            icon: "success",
            title: "Item despachado Exitosamente",
            showConfirmButton: false,
            timer: 2000,
          });
        } else {
          console.log(response.statusText);
          const t = translateBcError(response.statusText); // { message, correlationId, key }

          swal.fire({
            icon: "error",
            title: "Error al despachar",
            text: t.message, //response.statusText,
          });
        }
      })
      .catch((error) => {
        //errorMessage = error.message;
        console.error(error);
        const t = translateBcError(error.message); // { message, correlationId, key }

        swal.fire({
          icon: "error",
          title: "Error al despachar",
          text: t.message,
        });
      })
      .finally(() => {
        dialogRechazar.value = false;
        motivo.value = "";
      });
  } catch (error) {
    //errorMessage = error.message;
    console.error("There was an error!", error);
  } finally {
    isLoading.value = false;
  }
}

function despacharSolicitud() {
  try {
    if (lstDetalle.some((d) => d.codigoDespacho != "") == false) {
      dialogDespachar.value = false;

      swal.fire({
        icon: "error",
        title: "Error al despachar",
        text: "Debe ingresar al menos un codigo de despacho",
      });

      return;
    }

    let despachados = lstDetalle.filter(
      (d) => d.codigoDespacho != "" && d.estadoDespacho != "Despachado",
    );

    axios
      .put(
        store.state.url +
          "api/SolicitudCompra/DespacharSolicitud?solId=" +
          idSolicitud +
          "&usuario=" +
          usuario.value?.rut, //autorizador,
        despachados,
        { headers: { "Content-Type": "application/json" } },
      )
      .then((response) => {
        if (response.status == 200) {
          estado = response.data;
          console.log("Solicitud " + response.data);

          dialogDespachar.value = false;

          swal.fire({
            icon: "success",
            title: "Solicitud " + response.data,
            showConfirmButton: false,
            timer: 2000,
          });

          //getSolicitudCompra();
          router.push({ name: "BuscaSolicitud" });
        } else {
          console.log(response.statusText);
          const t = translateBcError(response.statusText); // { message, correlationId, key }

          swal.fire({
            icon: "error",
            title: "Error al despachar",
            text: t.message, //response.statusText,
          });
        }
      })
      .catch((error) => {
        //errorMessage = error.message;
        console.error(error);
      });
  } catch (error: any) {
    //errorMessage = error.message;
    console.error("There was an error!", error);
    const t = translateBcError(error.message); // { message, correlationId, key }

    swal.fire({
      icon: "error",
      title: "Error al despachar",
      text: t.message, //error.message,
    });
  }
}

async function cambiarEstadoSolicitud(nuevoEstado: string) {
  try {
    let url = "";

    if (
      nuevoEstado == "Aprobada" ||
      nuevoEstado == "Autorizada" ||
      nuevoEstado == "Rechazada" ||
      nuevoEstado == "Anulada"
    ) {
      url =
        store.state.url +
        "api/SolicitudCompra/UpdateEstado?id=" +
        idSolicitud +
        "&estado=" +
        nuevoEstado +
        "&autorizadorId=" +
        usuario.value?.rut + //autorizador.value +
        "&motivo=" +
        motivo.value;
    } else {
      url =
        store.state.url +
        "api/SolicitudCompra/UpdateEstado?id=" +
        idSolicitud +
        "&estado=" +
        nuevoEstado;
    }

    axios
      .put(url)
      .then((response) => {
        if (response.status == 200) {
          if (nuevoEstado == "Autorizada") {
            estado.value = "Autorizada";
            console.log("Solicitud Autorizada Exitosamente");

            dialogAutorizar.value = false;

            sendEmail(idSolicitud);

            swal.fire({
              icon: "success",
              title: "Solicitud Autorizada",
              showConfirmButton: false,
              timer: 2000,
            });

            router.push({ name: "BuscaSolicitud" });
          } else {
            if (nuevoEstado == "Aprobada") {
              estado.value = "Aprobada";
              console.log("Solicitud Aprobada Exitosamente");

              dialogAprobar.value = false;

              sendEmail(idSolicitud);

              swal.fire({
                icon: "success",
                title: "Solicitud Aprobada",
                showConfirmButton: false,
                timer: 2000,
              });

              router.push({ name: "BuscaSolicitud" });
            }

            if (nuevoEstado == "Guardada") {
              estado.value = "Guardada";
              console.log("Solicitud Guardada Exitosamente");

              // router.push({
              //   name: "EditarSolicitud",
              //   params: { solicitudId: route.params.solicitudId },
              // });

              router.push({
                path: "/EditarSolicitud",
                query: {
                  id: idSol.value,
                },
              });
            }

            if (nuevoEstado == "Rechazada") {
              console.log("Solicitud Rechazada Exitosamente");
              estado.value = "Rechazada";

              dialogRechazar.value = false;

              sendEmail(idSolicitud);

              swal.fire({
                icon: "success",
                title: "Solicitud Rechazada",
                showConfirmButton: false,
                timer: 2000,
              });

              router.push({ name: "BuscaSolicitud" });
            }

            if (nuevoEstado == "Enviada") {
              estado.value = "Enviada";
              console.log("Solicitud Enviada a Business Central Exitosa");

              // dialogAprobar = false;

              swal.fire({
                icon: "success",
                title: "Solicitud Enviada a Business Central Exitosa",
                showConfirmButton: false,
                timer: 2000,
              });
            }
          }
        }
      })
      .catch((error) => {
        //errorMessage = error.message;
        console.error(error);
      });
  } catch (error) {
    // errorMessage = error.message;
    console.error("There was an error!", error);
  }
}

function anularSolicitud() {
  try {
    axios
      .put(
        store.state.url +
          "api/SolicitudCompra/UpdateEstado?id=" +
          idSolicitud +
          "&estado=Anulada" +
          "&autorizadorId=" +
          usuario.value?.rut +
          "&motivo=" +
          motivo.value, //autorizador.value
      )
      .then((response) => {
        if (response.status == 200) {
          console.log("Solicitud Anulada");
          sendEmail(idSolicitud);

          dialogAutorizar.value = false;

          swal.fire({
            icon: "success",
            title: "Solicitud anulada",
            showConfirmButton: false,
            timer: 2000,
          });

          router.push({ name: "BuscaSolicitud" });
        } else {
          console.log(response.statusText);
          const t = translateBcError(response.statusText); // { message, correlationId, key }

          swal.fire({
            icon: "error",
            title: "Error al anular",
            text: t.message, //response.statusText,
          });
        }
      })
      .catch((error) => {
        // errorMessage = error.message;
        console.error(error);
        const t = translateBcError(error.message); // { message, correlationId, key }

        swal.fire({
          icon: "error",
          title: "Error al anular",
          text: t.message,
        });
      });
  } catch (error) {
    // errorMessage = error.message;
    console.error("There was an error!", error);
  }
}

function cerrarDespachado() {
  try {
    axios
      .put(
        store.state.url +
          "api/SolicitudCompra/CerrarDespachado?id=" +
          idSolicitud +
          "&usuario=" +
          usuario.value?.rut, //autorizador
      )
      .then((response) => {
        if (response.status == 200) {
          estado.value = "Cerrada";
          console.log("Solicitud Despachada Exitosamente");

          dialogCerrar.value = false;

          swal.fire({
            icon: "success",
            title: "Solicitud Cerrada",
            showConfirmButton: false,
            timer: 2000,
          });

          router.push({ name: "BuscaSolicitud" });
        } else {
          console.log(response.statusText);
          const t = translateBcError(response.statusText); // { message, correlationId, key }

          swal.fire({
            icon: "error",
            title: "Error al cerrar",
            text: t.message, //response.statusText,
          });
        }
      })
      .catch((error) => {
        //errorMessage = error.message;
        console.error(error);
        const t = translateBcError(error.message); // { message, correlationId, key }

        swal.fire({
          icon: "error",
          title: "Error al cerrar",
          text: t.message,
        });
      });
  } catch (error) {
    // errorMessage = error.message;
    console.error("There was an error!", error);
  }
}

async function sendEmail(idSol: string | undefined) {
  try {
    // await refreshToken()
    //   .then(async () => {
    // var token = cookies.get("token");

    await axios
      .post(store.state.url + "api/SolicitudCompra/SendEmail?idSol=" + idSol)
      .then((response) => {
        if (response.status == 200) {
          const recipients: string[] = response.data?.recipients || [];
          const message: string =
            response.data?.message || "Resultado de envío sin mensaje.";
          console.log(
            "[Email]",
            message,
            "Destinatarios:",
            recipients.join(", "),
          );
        } else {
          console.log(response.statusText);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    // })
    // .catch((error: any) => {
    //   console.log(error);
    // });
  } catch (error) {
    console.log(error);
  }
}

function setIcon(fileName: string) {
  try {
    var icon = "";

    var ext = fileName.substring(fileName.lastIndexOf(".") + 1);

    switch (ext) {
      case "pdf":
        icon = "mdi-file-pdf-box";
        break;

      case "doc":
        icon = "mdi-file-word";
        break;

      case "docx":
        icon = "mdi-file-word";
        break;

      case "xls":
        icon = "mdi-file-excel";
        break;

      case "xlsx":
        icon = "mdi-file-excel";
        break;

      case "ppt":
        icon = "mdi-file-powerpoint";
        break;

      case "pptx":
        icon = "mdi-file-powerpoint";
        break;

      case "jpeg":
        icon = "mdi-file-image";
        break;

      case "png":
        icon = "mdi-file-image";
        break;

      case "gif":
        icon = "mdi-file-image";
        break;

      case "jpg":
        icon = "mdi-file-image";
        break;

      case "7z":
        icon = "mdi-zip-box";
        break;

      case "rar":
        icon = "mdi-zip-box";
        break;

      case "zip":
        icon = "mdi-zip-box";
        break;

      case "txt":
        icon = "mdi-file-document";
        break;

      default:
        icon = "mdi-file";
        break;
    }

    // console.log(icon);

    return icon;
  } catch (error) {
    console.log(error);
  }
}

function sliceString(value: string) {
  return value.substring(value.lastIndexOf("/") + 1);
}

function exportarPdf(title: string) {
  isLoading.value = true;

  var url =
    store.state.url +
    "api/SolicitudCompra/ExportarSolicitud?idSol=" +
    idSolicitud;

  axios({
    method: "get",
    url,
    responseType: "arraybuffer",
  })
    .then((response) => {
      forceFileDownload(response, title);
    })
    .catch(() => console.log("error occured"))
    .finally(() => {
      isLoading.value = false;
    });
}

function forceFileDownload(response: any, title: string) {
  //console.log(title);
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", title);
  document.body.appendChild(link);
  link.click();
}

function compraTotal() {
  total.value = lstDetalle.reduce((acc, item) => acc + (item.total ?? 0), 0);
}

function rendicionTotal() {
  total.value = lstDetalle.reduce((acc, item) => acc + (item.monto ?? 0), 0);
}

function formatMoney(value: number) {
  return new Intl.NumberFormat("es-CL", {
    style: "currency",
    currency: "CLP",
    minimumFractionDigits: 2,
  }).format(value);
}

function formatTotal(value: number) {
  return new Intl.NumberFormat("es-CL", {
    style: "currency",
    currency: "CLP",
  }).format(value);
}

function filterNumber(evt: any) {
  evt = evt ? evt : window.event;
  let expect = evt.target.value.toString() + evt.key.toString();

  if (!/^[0-9]*\.?[0-9]*$/.test(expect)) {
    evt.preventDefault();
  } else {
    return true;
  }
}

function navigate() {
  router.push({
    path: "/SolCompra",
    query: {
      id: idSol.value,
    },
  });
}

async function enviarRetiro() {
  var errorMsg: string[] = [];
  var enviadas = [];

  if (
    lstDetalle.some(
      (d) => /*d.cantidadRetirar == 0 ||*/ d.cantidadRetirar == null,
    )
  ) {
    swal.fire({
      icon: "error",
      title: "Error al enviar a Business Central",
      text: "Debe ingresar la cantidad a retirar en todos los items.",
    });
    return;
  }

  let puedeRetirar: boolean = true;

  // lstDetalle.forEach(async (det) => {
  for (let det of lstDetalle) {
    let retirados = await getTotalRetirados(
      currentSolicitud.value?.encabezado.code || 0,
      det.codigoMaterial || "",
    ); //.then(async (retirados) => {

    if (
      det.cantidadRetirar != null &&
      retirados + Number(det.cantidadRetirar) > (det.cantidad ?? 0)
    ) {
      puedeRetirar = false;

      swal.fire({
        icon: "error",
        title: "Error al enviar a Business Central",
        text:
          "La cantidad a retirar no puede ser mayor al stock. Ya han sido retirados " +
          retirados +
          " items del material " +
          det.codigoMaterial,
      });
      return;
    }

    enabledRetiroBC365.value = true;
    isLoading.value = true;
    // let detalle = lstDetalle;
    // });
  }
  // });

  if (currentSolicitud.value && currentSolicitud.value.encabezado.companyId) {
    await getBodegas(currentSolicitud.value.encabezado.companyId);
  }

  let bodega =
    lstBodegas.value.find(
      (b) => b.displayName == currentSolicitud.value?.encabezado.bodegaName,
    )?.code || "";

  // enabledRetiroBC365.value = true;
  // isLoading.value = true;

  // let detalle = lstDetalle.filter(
  //   (d) => d.cantidadRetirar != null && d.cantidadRetirar > 0
  // );

  let detalle = lstDetalle;

  if (!puedeRetirar) {
    return;
  }

  await axios
    .post(
      store.state.url +
        "api/RetiroBodega/EnvioBC?company=" +
        currentSolicitud.value?.encabezado.companyId +
        "&solCode=" +
        code.value +
        "&bodega=" +
        bodega,
      detalle,
    )
    .then(async (response) => {
      if (response.status == 200 || response.status == 204) {
        // console.log("exito");

        var adjts = response.data as ItemJournalLineResponseList[];

        if (adjts.length == 0) {
          swal.fire({
            icon: "info",
            title: "No se enviaron solicitudes",
            text: "No se encontraron solicitudes para enviar.",
          });
          return;
        }

        for (var res of adjts) {
          if (res.message?.includes("error")) {
            errorMsg.push(res.message + "\n\n");
          } else {
            if (res.postJrnlMessage?.includes("Error")) {
              errorMsg.push(res.postJrnlMessage + "\n\n");
            } else {
              enviadas.push(res.id);
            }
          }
        }

        if (errorMsg.length > 0) {
          // swal.fire({
          //   icon: "error",
          //   title:
          //     "Error al enviar " +
          //     errorMsg.length +
          //     " solicitudes a Business Central",
          //   text: errorMsg.join(),
          // });

          showMultipleErrors(errorMsg.map((msg) => ({ message: msg })));
        } else {
          let terminado = adjts[0].terminado;

          if (terminado) {
            // cambiarEstadoSolicitud("Enviada");
            estado.value = "Enviada";

            //si tidos los items tienen cantidad a retirar igual a 0
            await cambiarEstadoSolicitud("Enviada");

            swal.fire({
              icon: "success",
              title: "Ajustes enviados correctamente",
              text:
                "Se terminaron de despachar todos los items de la solicitud SOC-" +
                code.value.toString().padStart(7, "0"),
            });
          } else {
            // cambiarEstadoSolicitud("En Envio");
            // estado.value = "En Envio";
            await retiroFinalizado(
              currentSolicitud.value?.encabezado.code || 0,
              "",
            );

            swal.fire({
              icon: "success",
              title: "Ajustes enviados correctamente",
              text:
                "Se despacharon parcialmente los items de la solicitud SOC-" +
                code.value.toString().padStart(7, "0"),
            });
          }

          let adjuntos = lstDetalle.filter((d) => d.chosenFile != null).length;
          if (adjuntos > 0) {
            if (currentSolicitud.value) {
              await submitFile(currentSolicitud.value);
            }
          }

          router.push({ name: "BuscaSolicitud" });
        }
      }
    })
    .catch((error) => {
      console.error("There was an error!", error);
      const t = translateBcError(error.message); // { message, correlationId, key }

      swal.fire({
        icon: "error",
        title: "Error al enviar Retiro Bodega a Business Central",
        text: t.message, //error.message,
      });
    })
    .finally(() => {
      isLoading.value = false;
      enabledRetiroBC365.value = true;
    });
  // }
}

async function anularDetalle() {
  if (
    lstDetalle.filter((d) => d.estadoDespacho != "Enviada" && d.isSelected)
      .length == 0
  ) {
    swal.fire({
      icon: "error",
      title: "Error al anular detalle",
      text: "Debe seleccionar al menos un Item",
    });

    enabledBC365.value = true;
    return;
  }

  //obtener los items seleccionados
  let anuladas = lstDetalle.filter((d) => d.isSelected);

  axios
    .put(
      store.state.url +
        "api/SolicitudCompra/AnularDetalle?solId=" +
        idSolicitud +
        "&usuario=" +
        usuario.value?.rut, //autorizador,
      anuladas,
      { headers: { "Content-Type": "application/json" } },
    )
    .then((response) => {
      if (response.status == 200) {
        estado = response.data;
        console.log("Solicitud " + response.data);

        dialogDespachar.value = false;

        swal.fire({
          icon: "success",
          title: "Detalle Anulado Exitosamente",
          showConfirmButton: false,
          timer: 2000,
        });

        //getSolicitudCompra();
        router.push({ name: "BuscaSolicitud" });
      } else {
        console.log(response.statusText);
        const t = translateBcError(response.statusText); // { message, correlationId, key }

        swal.fire({
          icon: "error",
          title: "Error al despachar",
          text: t.message, //response.statusText,
        });
      }
    })
    .catch((error) => {
      //errorMessage = error.message;
      console.error(error);
    });
}

async function anularDetalleRetiro() {
  if (lstDetalle.filter((d) => d.isSelected).length == 0) {
    swal.fire({
      icon: "error",
      title: "Error al anular detalle",
      text: "Debe seleccionar al menos un Item",
    });

    return;
  }

  //obtener los items seleccionados
  let anuladas = lstDetalle.filter((d) => d.isSelected);

  axios
    .put(
      store.state.url +
        "api/RetiroBodega/AnularDetalleRetiro?solId=" +
        idSolicitud +
        "&usuario=" +
        usuario.value?.rut,
      anuladas,
      { headers: { "Content-Type": "application/json" } },
    )
    .then((response) => {
      if (response.status == 200) {
        estado = response.data;
        console.log("Solicitud " + response.data);

        swal.fire({
          icon: "success",
          title: "Detalle Anulado Exitosamente",
          showConfirmButton: false,
          timer: 2000,
        });

        router.push({ name: "BuscaSolicitud" });
      } else {
        console.log(response.statusText);
        const t = translateBcError(response.statusText); // { message, correlationId, key }

        swal.fire({
          icon: "error",
          title: "Error al anular detalle",
          text: t.message, //response.statusText,
        });
      }
    })
    .catch((error) => {
      console.error(error);

      swal.fire({
        icon: "error",
        title: "Error al anular detalle",
        text: error.message,
      });
    });
}

async function getTotalRetirados(solid: number, item: string): Promise<number> {
  try {
    isLoading.value = true;

    const response = await axios.get(
      store.state.url +
        "api/RetiroBodega/GetTotalRetirados?solId=" +
        solid +
        "&item=" +
        item,
    );
    if (response.status == 200) {
      return response.data as number;
    } else {
      console.log(response.statusText);
      return 0;
    }
  } catch (error) {
    console.error("There was an error!", error);
    return 0;
  } finally {
    isLoading.value = false;
  }
}

async function retiroFinalizado(solid: number, item: string) {
  try {
    const response = await axios.get(
      store.state.url +
        "api/RetiroBodega/RetiroFinalizado?encabezadoId=" +
        currentSolicitud.value?.encabezado.id,
    );
    if (response.status == 200) {
      console.log("Retiro finalizado:", response.data);
    } else {
      console.log(response.statusText);
    }
  } catch (error) {
    console.error("There was an error!", error);
  }
}

async function submitFile(solicitud: SolicitudCompra) {
  // Evitar ejecución múltiple
  if (isUploadingFiles.value) {
    console.log("Ya se están subiendo archivos, evitando duplicidad");
    return;
  }

  isUploadingFiles.value = true;

  try {
    const files = new FormData();

    for (let i = 0; i < (lstDetalle?.length || 0); i++) {
      if (lstDetalle[i]?.chosenFile != null) {
        files.append("files", lstDetalle[i]?.chosenFile || "");
      }
    }

    // Si no hay archivos, no hacer la petición
    if (files.getAll("files").length === 0) {
      console.log("No hay archivos para subir");
      return;
    }

    const headers = { "Content-Type": "multipart/form-data" };

    await axios
      .post(
        store.state.url +
          "api/RetiroBodega/UploadRetiroAdjuntos?solId=" +
          currentSolicitud.value?.encabezado.id,
        files,
        {
          headers,
        },
      )
      .then(async (res) => {
        if (res.status == 200) {
          console.log("Archivos subidos correctamente");
        } else {
          console.log("Error al cargar archivo, status code:" + res.status);
        }
      })
      .catch((error) => {
        console.error("Error al subir archivos:", error);
      });
  } finally {
    isLoading.value = false;
    isUploadingFiles.value = false;
  }
}

// Ejemplo: response.data.errors = [{ message: "Falta dimensión..." }, ...]
function showMultipleErrors(errors: Array<{ message: string }>) {
  // Traducir cada error usando el traductor
  const translatedErrors = errors.map((e) => {
    const translated = translateBcError({ message: e.message });
    return translated.message;
  });

  // Eliminar mensajes duplicados usando Set
  const uniqueMessages = [...new Set(translatedErrors)];

  // Generar HTML para cada mensaje único
  const lis = uniqueMessages.map((msg) => `<li>${msg}</li>`).join("");

  swal.fire({
    icon: "error",
    title: "No se pudo enviar a Business Central",
    html: `<ul style="text-align:left;margin:0 0 8px 18px">${lis}</ul>`,
    confirmButtonText: "Entendido",
  });
}
</script>
